import React from 'react';
import { ShowIf } from 'components/utils';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import { GiaiQuyetDonThu } from 'api';
import { Toastr } from 'modules/toastr';
import { TextArea, TextMessage } from 'components/tt-forms/common';
import { validatable } from 'components/utils';
import { ContainerFileDinhKem } from 'components/upload';
import { msg } from "constants/message";
import { getParams } from 'modules/giai-quyet-don/subView/GetParams.jsx';
import { DropDownMulipleUse, DropDownChonPhongBanThuocCoQuan, DropDownChonCanBoXuLy } from 'components/tt-forms';
import {BlockGiaiQuyetDonInfo, BlockBanHanhQuyetDinhView} from 'modules/giai-quyet-don/subView';

class LanhDaoGiaoViecTheoDoiGiamSat extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      id: this.props.id,
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
      loaiDon: this.props.loaiDon,

      dataDetail: [],

      nextState: '',

      hideDropdown: false,

      lanhDaoChiDinh: '',
      yKienGiaiQuyet: '',
    }
  }

  componentDidMount() {
    this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      id: nextProps.id,
      loaiDon: nextProps.loaiDon,
      thongTinGiaiQuyetDonId: nextProps.thongTinGiaiQuyetDonId
    })

    if(this.props.dataNextStates != nextProps.dataNextStates && nextProps.dataNextStates.length > 0) {
      this.checkOnlyState(nextProps.dataNextStates);
    }
  }

  getThongTinGiaiQuyetDon(thongTinGiaiQuyetDonId) {
    GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: thongTinGiaiQuyetDonId }).then(res => {
      if (res.data) {
        this.setState({
          dataDetail: res.data,
          nextState: res.data.nextStateInfo ? res.data.nextStateInfo.type : '',
          canBoXuLyChiDinh: res.data.canBoXuLyChiDinhInfo ? res.data.canBoXuLyChiDinhInfo.congChucId : '',
          phongBanGiaiQuyet: res.data.phongBanGiaiQuyetInfo ? res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
          yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : '',
        });
      }
    }).then(() => {
      if(this.props.dataNextStates && this.props.dataNextStates.length > 0) {
        this.checkOnlyState(this.props.dataNextStates);
      }
    });
  }

  checkOnlyState(dataNextStates) {
    if (this.state.nextState) {
      //do nothing
    } else {
      this.setState({
        nextState: dataNextStates[0].type
      })
    }
  }

  onClickClose() {
    browserHistory.goBack();
  }

  handleChange(name, e) {
    this.setState({
      [name]: e.target.value
    });
    if (name == 'nextState') {
      this.setState({
        canBoXuLyChiDinh: '',
        phongBanGiaiQuyet: ''
      })
    }
    if (name == 'phongBanGiaiQuyet') {
      this.setState({
        canBoXuLyChiDinh: ''
      })
    }
  }

  getParams() {
    let dataGiaiQuyetDon = this.state.dataDetail;
    let params = getParams(dataGiaiQuyetDon, this.state.id);
    if(this.state.canBoXuLyChiDinh) {
      params.canBoXuLyChiDinh = {
        id: Number(this.state.canBoXuLyChiDinh)
      }
    } else {
      params.canBoXuLyChiDinh = null
    }

    if(this.state.phongBanGiaiQuyet) {
      params.phongBanGiaiQuyet = {
        id: Number(this.state.phongBanGiaiQuyet)
      }
    } else {
      params.phongBanGiaiQuyet = null
    }

    let selectedState = this.props.dataNextStates.filter(state => {
      return state.type == this.state.nextState
    });

    if(selectedState.length > 0) {
      params.nextState = {
        id: Number(selectedState[0].stateId)
      }
    } else {
      params.nextState = null
    }

    params.yKienGiaiQuyet = this.state.yKienGiaiQuyet ? this.state.yKienGiaiQuyet : '';

    return params;
  }

  handleSave() {
     this.setState({
      btnLoading: true,
      btnSaveLoading: true
    });

    let params = this.getParams();
    this.saveGiaiQuyetDon(params, 'gqdLuu');
  }

  handleKetThuc() {
    if (this.validateSubmitForm()) {
      this.setState({
        btnLoading: true
      });
      let selectedState = this.props.dataNextStates.filter(state => {
          return state.type == this.state.nextState
      });
      let params = {
        thongTinGiaiQuyetDon: {
          id: Number(this.props.thongTinGiaiQuyetDonId),
        },
        phongBanGiaiQuyet: {
          id: Number(this.state.phongBanGiaiQuyet)
        },
        nextState: {
          id: Number(selectedState[0].stateId),
        },
        yKienGiaiQuyet: this.state.yKienGiaiQuyet
      }
      if (this.state.canBoXuLyChiDinh) {
        params.canBoXuLyChiDinh = {
          id: Number(this.state.canBoXuLyChiDinh)
        }
      }
      this.postGiaiQuyetDon( params, 'gqdLanhDaoGiaoViec');
    }
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    })
    return pass;
  }

  saveGiaiQuyetDon(params, message) {
    GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({id: this.state.thongTinGiaiQuyetDonId},params).then(res => {
      this.onClickClose(true);
      Toastr(message ? msg[message] : msg.luuGiaiQuyetDonThanhCong, 'success');
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  postGiaiQuyetDon(params, message) {
    GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(res => {
      this.props.dispatch({type: 'REFRESH_MENU', value: true});
      this.onClickClose(true);
      Toastr(message ? msg[message] : msg.giaiQuyetDon, 'success');
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  render() {
    let DataDetail = this.state.dataDetail;

    return (
      <section className="wrap-block">
        <BlockGiaiQuyetDonInfo donInfo={this.props.donInfo} thongTinGQD={this.state.dataDetail}/>

        <div className="row pl15 pr15">
          <BlockBanHanhQuyetDinhView donInfo={this.props.donInfo} thongTinGQD={this.state.dataDetail} dataKetLuanNoiDungKhieuNai={this.props.dataKetLuanNoiDungKhieuNai}/>
          <div className="col-100 no-gutter mt5">
            <h2 className="title-14 mb15">Thông tin giải quyết</h2>
          </div>
          <div className="row pl10 pr10">
            <ShowIf condition={!this.state.hideDropdown}>
              <DropDownMulipleUse
                require
                selectedValue={this.state.nextState}
                label="Giao xử lý"
                onChange={this.handleChange.bind(this, 'nextState')}
                data={this.props.dataNextStates}
                bindValidator={this}
                keyName='type'
                valueName='tenVietTat'
                name="dropdownHuongXuLy" />
            </ShowIf>

            <ShowIf condition={this.state.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' || this.state.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO'}>
              <DropDownChonPhongBanThuocCoQuan require
                bindValidator={this}
                selectedValue={this.state.phongBanGiaiQuyet}
                isValid={this.props.validate}
                onChange={this.handleChange.bind(this, 'phongBanGiaiQuyet')}
                name="dropdownChonPhongBanThuocCoQuan" />
            </ShowIf>

            {/* <ShowIf condition={ this.state.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG'  && this.state.phongBanGiaiQuyet != ''}>
              <DropDownChonCanBoXuLy
                label="Lãnh đạo phòng"
                vaiTro="TRUONG_PHONG"
                selectedValue={this.state.canBoXuLyChiDinh}
                phongBanId={this.state.phongBanGiaiQuyet}
                onChange={this.handleChange.bind(this, 'canBoXuLyChiDinh')}
                name="dropdownChonCanBoXuLyTruongPhong" />
            </ShowIf> */}

            <ShowIf condition={ this.state.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO' && this.state.phongBanGiaiQuyet != ''}>
              <DropDownChonCanBoXuLy require
                bindValidator={this}
                vaiTro="CHUYEN_VIEN"
                selectedValue={this.state.canBoXuLyChiDinh}
                phongBanId={this.state.phongBanGiaiQuyet}
                onChange={this.handleChange.bind(this, 'canBoXuLyChiDinh')}
                name="dropdownChonCanBoXuLyChuyenVien" />
            </ShowIf>
          </div>
          <div className="row pl10 pr10">
            <TextArea
              label="Ý kiến xử lý"
              value={this.state.yKienGiaiQuyet}
              onChange={this.handleChange.bind(this, 'yKienGiaiQuyet')}
              name="textareaBanLanhDaoTTXM" />
          </div>

          <ShowIf condition={this.state.showFile}>
            <div className="col-100 pb5 no-gutter">
              <ContainerFileDinhKem name="GiaoCQDT" label="Danh sách văn bản xử lý" hideDescription={true} bindValidator={this} dataShow={this.props.listTaiLieuVanThuGiaiQuyetDon} disableAttachFile={true}/>
            </div>
          </ShowIf>
          <ShowIf condition={!DataDetail.boSungThongTin && (DataDetail.noiDungBoSungHoSo != '' && DataDetail.noiDungBoSungHoSo != null)}>
            <div className="col-100 no-gutter">
              <div className="wrap-big-line pt5 pb15">
                <span className="big-border"></span>
              </div>
              <div className="col-100 no-gutter mt5">
                <h2 className="title-14 mb15">BỔ SUNG THÔNG TIN</h2>
                <div className="row pl10 pr10">
                  <div className="col-50 no-gutter">
                    <TextMessage className="col-50 mb0-18" label="Lý do bổ sung:" value={String(DataDetail.noiDungBoSungHoSo)}/>
                  </div>
                </div>
              </div>
              <div className="col-100 pb5 no-gutter">
                <ContainerFileDinhKem name="BoSungTT" label="Danh sách văn bản bổ sung" hideDescription={true} dataShow={DataDetail.listTaiLieuVanThuBoSungHoSo} disableAttachFile={true}/>
              </div>
            </div>
          </ShowIf>
        </div>
        <div className='col-100 no-gutter'>
          <div className='wrap-gqd-kqt'>
            <ShowIf condition={DataDetail.lanhDaoView != true && !DataDetail.boSungThongTin}>
              <div className="box-bottom gqd-wrap pt35 mt20">
                <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
                <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this)}><span>Lưu tạm</span></Link>
                <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline') : "btn-action btn-move action-todo"} onClick={this.handleKetThuc.bind(this)}><span>Giao việc</span></Link>
              </div>
            </ShowIf>
          </div>
        </div>
      </section>
    );
  }
}

LanhDaoGiaoViecTheoDoiGiamSat.defaultProps = {
  listNextStates: [],
  dataKetLuanNoiDungKhieuNai: [],
  dataKetQuaThucHien: [],
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  onSave: false
}

function bindStateToProps(state) {
  return {
    lanhDaoList: state.duLieuHeThong.lanhDaoList,
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    dataKetQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  }
}

export default connect(bindStateToProps)(validatable(LanhDaoGiaoViecTheoDoiGiamSat));



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-giai-quyet/lanh-dao/LanhDaoGiaoViecTheoDoiGiamSat.jsx